import { rem, Text } from "@mantine/core";
import { modals } from "@mantine/modals";

export const CancelModal = (cancel: () => void) => {
  modals.openConfirmModal({
    title: <strong>Warning</strong>,
    yOffset: rem(200),
    children: <Text size="sm">You have unsaved changes, are you sure you want to continue ?</Text>,
    labels: { confirm: "Close without saving", cancel: "Keep editing" },
    onConfirm: cancel
  });
};
